module.exports = __webpack_public_path__ + "gs.8b0eac6d198952c3b715.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/gs.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/gs.svg
// module chunks = styles